/* global axios */
import ApiClient from './ApiClient';

class SlaAPI extends ApiClient {
  constructor() {
    super('sla_policies', { accountScoped: true });
  }

  softDelete(id) {
    return axios.delete(`${this.url}/${id}/soft_delete`);
  }

  reactivate(id) {
    return axios.post(`${this.url}/${id}/reactivate`);
  }

  hardDelete(id) {
    return axios.delete(`${this.url}/${id}/hard_delete`);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }
}

export default new SlaAPI();
